import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { SEA_SURFACE_TEMPERATURE_LEGEND } from './sea-surface-temperature.legend';
import { SEA_SURFACE_TEMPERATURE_PRODUCT_DATA } from './sea-surface-temperature.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class SeaSurfaceTemperaturePluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(
    SEA_SURFACE_TEMPERATURE_PRODUCT_DATA,
    {
      legend: SEA_SURFACE_TEMPERATURE_LEGEND,
      twcLayerTypes: ['web-tile']
    }
  );
}
